import comp from './index.vue'
comp.install = Vue => Vue.component(comp.name, comp)
export default comp
